import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { FeatureFlag } from "../models/feature-flag-model";

type FeatureFlagStore = {
  featureFlagList: FeatureFlag[];
  setFeatureFlag: (featureFlag: FeatureFlag, enabled?: boolean) => void;
  removeFeatureFlag: (featureFlagId: string) => void;
};

export const useFeatureFlagStore = create<FeatureFlagStore>()(
  persist(
    (set) => ({
      featureFlagList: [],
      setFeatureFlag: (featureFlag: FeatureFlag, enabled?: boolean) => {
        set((state) => ({
          featureFlagList: [
            ...state.featureFlagList.filter((flag) => flag.id !== featureFlag.id),
            { ...featureFlag, enabled: enabled === undefined ? featureFlag.enabled : enabled },
          ],
        }));
      },
      removeFeatureFlag: (featureFlagId: string) => {
        set((state) => ({
          featureFlagList: state.featureFlagList.filter((flag) => flag.id !== featureFlagId),
        }));
      },
    }),
    {
      name: "feature-flag-override", // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
    },
  ),
);
